<section class="{{ cssClass }}">
  <ion-card-subtitle class="list-subtitle ion-text-capitalize">{{ label }}</ion-card-subtitle>
  <ion-card-title class="list-title">{{ value }}</ion-card-title>
</section>
